import axios from "axios";

const contactMethodMap = {
    email: 'E-mailadres',
    phone: 'Telefoon',
};

export default async function sendContactRequest({contactMethod, ...data}) {
    try {
        const url = window.SiteConfig.baseUrl;

        await axios.post(
            `${url}/ajax/request-contact-us`,
            {
                ...data,
                contact_method: contactMethodMap[contactMethod] ?? '',
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
    } catch (error) {
        console.error("Error sending contact request:", error);
        throw error;
    }
}